import React, { Component } from 'react'
import i18next from 'i18next'
import { Row, Col } from 'react-bootstrap'

import GridContainer from './GridContainer'
import UnitForm from './UnitForm'
import Loading from './Loading'

export default class UnitEdit extends Component {
  componentDidMount() {
    this.props.getUnit(this.props.params.uuid)
  }

  handleSubmit = editInput =>
    this.props.editUnit(this.props.currentOrganisationId, this.props.unit.uuid, editInput)

  render() {
    const { unit, isLoading } = this.props

    return (
      <GridContainer>
        <div style={{ marginBottom: 365 }}>
          <Row>
            <Col md={12}>
              <header>
                <h1>{i18next.t('unit_edit')}</h1>
              </header>
            </Col>
          </Row>

          <Loading inline={true} isReady={!isLoading && unit}>
            <UnitForm unit={this.props.unit} onSubmit={this.handleSubmit} />
          </Loading>
        </div>
      </GridContainer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/UnitEdit.js